module.exports = __webpack_public_path__ + "img/socolow-daedalus-witnessing-as-published-fall-2020.pdf";